import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  color?: string;
};

const Check: FC<Props> = ({ color = colors['--black'] }) => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 4L4 7L9 1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Check;
